import { format } from "date-fns";

export const formatDateForApi = (value: Date | string) => {
  return format(value, 'YYYY-MM-DD');
}

export const formatDatetimeForApi = (value: Date | string) => {
  return format(value, 'YYYY-MM-DD HH:mm:ss');
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/formatDateForApi.ts